/* eslint-disable react/no-array-index-key */
import React, { useCallback, useState, useRef, useEffect, useMemo } from 'react';
import { useUpdate } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
import PickerCol from './picker-col';
const prefixCls = createPrefixCls('picker');
export const getTreeData = (data, value) => {
    const treeData = [];
    const loop = (child, zIndex) => {
        child.map((el) => {
            treeData[zIndex] = treeData[zIndex] || [];
            treeData[zIndex].push(Object.assign({}, el));
        });
        const nextChild = child.find((el) => {
            return el.value === (value ? value[zIndex].value : child[0].value);
        });
        if (nextChild && nextChild.children) {
            loop(nextChild.children, zIndex + 1);
        }
    };
    loop(data, 0);
    return treeData;
};
export const TreePicker = ({ data, defaultValue, onChange }) => {
    const defaultValueRef = useRef(defaultValue);
    const initTreeData = useMemo(() => {
        return getTreeData(data, defaultValueRef.current);
    }, [data]);
    const [pickerValue, setPickerValue] = useState(defaultValueRef.current);
    const [treeData, setTreeData] = useState(initTreeData);
    const pickerIndex = useRef();
    useEffect(() => {
        setTreeData(getTreeData(data, pickerValue));
    }, [data, pickerValue]);
    const handleChange = useCallback((colIndex) => {
        return (index) => {
            pickerIndex.current = colIndex;
            pickerValue[colIndex] = treeData[colIndex][index];
            const _pickerValue = [];
            const loop = (child, zIndex) => {
                const row = child.find((el) => {
                    return pickerValue[zIndex] && el.value === pickerValue[zIndex].value;
                });
                if (row) {
                    _pickerValue[zIndex] = row;
                    if (row.children) {
                        loop(row.children, zIndex + 1);
                    }
                }
                else {
                    _pickerValue[zIndex] = child[0];
                    if (child[0].children) {
                        loop(child[0].children, zIndex + 1);
                    }
                }
            };
            loop(data, 0);
            setPickerValue([..._pickerValue]);
        };
    }, [pickerValue, treeData, data]);
    useUpdate(() => {
        pickerIndex.current && onChange(pickerValue, pickerIndex.current);
    }, [onChange, pickerIndex, pickerValue]);
    return (React.createElement("div", { className: prefixCls('content') },
        React.createElement("div", { className: prefixCls('mask') }),
        React.createElement("div", { className: prefixCls('indicator') }),
        React.createElement("div", { className: prefixCls('cols') }, treeData.map((el, index) => {
            return React.createElement(PickerCol, { key: index, data: el, value: pickerValue[index], onChange: handleChange(index) });
        }))));
};
export default TreePicker;
